module.exports = __webpack_public_path__ + "img/avatar2.9b6132a7.png";